import './RangeLegend.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var legendContainer = _7a468({defaultClassName:'_lvrd9i0-3-8-0',variantClassNames:{isVertical:{true:'_lvrd9i1-3-8-0',false:'_lvrd9i2-3-8-0'}},defaultVariants:{},compoundVariants:[]});